<ng-container *transloco="let transloco">
  <div class="relative w-full h-full flex flex-col bg-white">
    <form [formGroup]="resetPasswordGroup" class="relative w-full h-full flex flex-col overflow-y-scroll">
      <div class="mt-6 w-full flex flex-col gap-[10px]">
        <div class="font-[600] text-[16px] leading-[19px] transition-all transform duration-200" [ngClass]="{ 'text-black/40': resetPasswordGroup.controls['password'].errors, 'text-black': !resetPasswordGroup.controls['password'].errors }">
          {{ 'New Password' | transloco }}
        </div>
        <input class="w-full px-2 py-4 border-2 border-black/20 outline-2 outline-black rounded" type="password" [placeholder]="transloco('Minimum 8 characters, including a special character')" autofocus formControlName="password" />
      </div>
      <div class="mt-6 w-full flex flex-col gap-[10px]">
        <div
          class="font-[600] text-[16px] leading-[19px] transition-all transform duration-200"
          [ngClass]="{ 'text-black/40': resetPasswordGroup.controls['passwordConfirm'].errors, 'text-black': !resetPasswordGroup.controls['passwordConfirm'].errors }">
          {{ 'New Password Confirm' | transloco }}
        </div>
        <input class="w-full px-2 py-4 border-2 border-black/20 outline-2 outline-black rounded" type="password" [placeholder]="transloco('Re-enter your password')" autofocus formControlName="passwordConfirm" />
      </div>
    </form>
    <div class="mt-12 flex-none relative w-full h-[55px] flex flex-row gap-[14px]">
      <button class="w-full h-full flex justify-center items-center rounded-lg bg-black text-[16.8px] font-[600] text-white disabled:bg-gray-300" (click)="onClickSubmit()" [disabled]="!resetPasswordGroup.valid">
        {{ 'Reset Password' | transloco }}
      </button>
    </div>
  </div>
</ng-container>
